












import { defineComponent, PropType } from '@vue/composition-api';
import cSeasonsDay                   from '@/views/seasons/components/seasons-calendar/seasons-day/seasons-day.component.vue';
import { MONTH_NAMES }               from '@/helpers/variables';
import { useGlobals }                from '@/hooks/use-globals';

export default defineComponent({
  name: 'cSeasonsMonth',
  components: {
    cSeasonsDay,
  },
  props: {
    month: {
      required: true,
      type: Number,
    },
    daysInMonth: {
      required: true,
      type: Array as PropType<string[]>,
    },
  },
  setup() {
    const { i18n } = useGlobals();

    return {
      i18n,
      MONTH_NAMES,
    };
  },
});
